import {useEffect, useRef} from 'react';

import {LanguageSelectIcon} from '@/components/Icons';
import {StickyPageLayout} from '@/components/Layout';
import {PopupFullPage} from '@/components/Popup';
import {LANGUAGE_SELECT_PAGE_HEADER_TITLE} from '@/consts/localization/localizationKeys';
import useIsDesktopLayout from '@/hooks/layout/useIsDesktopLayout';
import useModalRoute from '@/hooks/useModalRoute';
import {getLocalizedStrings} from '@/services/localization/localizationService';
import modalService from '@/services/modalService';
import appRouterService from '@/services/route/appRouterService';
import {WARNING_BANNER_SOURCE_TYPES, WarningBanners, WarningBannersTop} from '@/views/WarningBanners';

import {LANGUAGE_SELECT_TITLE_ID} from '../../consts/languageSelectConsts';
import useLanguageSelect from '../../hooks/useLanguageSelect';
import LanguageSelectContentSelectList from '../LanguageSelectContent/LanguageSelectContentSelectList';
import LanguageSelectContentTitle from '../LanguageSelectContent/LanguageSelectContentTitle';
import LanguageSelectPopupTrigger from './LanguageSelectPopupTrigger';

const LanguageSelectPopup = ({modalType}) => {
    const popupRef = useRef(null);
    const isDesktopLayout = useIsDesktopLayout();
    const {languageCode, selectListData, handleLanguageChange} = useLanguageSelect();
    const closeModal = () => modalService.hideModal(modalType);
    const {onClose} = useModalRoute({modalType, closeModal});
    const localizedStrings = getLocalizedStrings();

    //language select popup is absent for desktop design
    useEffect(() => {
        if (isDesktopLayout) {
            appRouterService.forwardToConsumerProfilePage();
        }
    }, [isDesktopLayout]);

    return (
        <PopupFullPage overlayRef={popupRef} className='flex flex-col' aria-labelledby={LANGUAGE_SELECT_TITLE_ID}>
            <WarningBannersTop source={WARNING_BANNER_SOURCE_TYPES.LANGUAGE_SELECT} containerRef={popupRef} />
            <StickyPageLayout
                className='items-center'
                headerOptions={{
                    onBack: onClose,
                    title: localizedStrings[LANGUAGE_SELECT_PAGE_HEADER_TITLE],
                }}
                contentClassName='flex flex-1 flex-col items-center h-full'
            >
                <div className='flex h-full w-full flex-col items-center justify-center px-4'>
                    <LanguageSelectIcon />
                    <LanguageSelectContentTitle className='mb-8 mt-2 text-start' renderAs='h1' />

                    <LanguageSelectContentSelectList
                        selectedValue={languageCode}
                        data={selectListData}
                        onChange={handleLanguageChange}
                    />
                </div>

                <div className='flex-1' />
                <WarningBanners source={WARNING_BANNER_SOURCE_TYPES.LANGUAGE_SELECT} />
            </StickyPageLayout>
        </PopupFullPage>
    );
};

LanguageSelectPopup.Trigger = LanguageSelectPopupTrigger;

export default LanguageSelectPopup;
